import React, { Component } from 'react';
import asyncWrapper from '../../../../../../shared/javascripts/hocs/asyncWrapper'
import Loading from '../../../../../../shared/javascripts/components/Loading'
import { Chart } from "react-google-charts";

import UserProgressApi from '../../../api/UserProgressApi'

class GameScore extends Component {
  constructor(props) {
    super(props)
    this.state = {data: []}
  }

  componentDidMount() {
    UserProgressApi.fetchGameScores(this.props.user.id)
      .then(this.props.handleErrors)
      .then(response => {
        this.setState({data: response},
          ()=>this.props.setLoading()
        )
      }).catch(error => console.log(error))
  }

  render() {
    if(this.props.loading) {return <Loading />}
    return (
      <Chart
        chartType="ColumnChart"
        data={this.state.data}
        width="100%"
        options={
          {"title": `Game Score (Last 15 Games)`,
            chartArea: { width: '60%' },
            "vAxis": {
              "title": "Percentage(%)",
              minValue: 0,
              maxValue: 100,
              viewWindow: {
                min: 0,
                max: 100
              }
            },
            "hAxis": {"title": "Game"}
          }}
      />
    )
  }
}

export default asyncWrapper(GameScore)


// WEBPACK FOOTER //
// ./src/reports/google_play/javascripts/components/User/Scores/GameScore.jsx